// removed by extract-text-webpack-plugin
module.exports = {"mobileVersion":"AppGithubCorner__mobileVersion__3R88L","desktopVisible":"AppGithubCorner__desktopVisible__2zeDi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AppGithubCorner/AppGithubCorner.scss
// module id = 234
// module chunks = 0